import { Badge, IconButton, useTheme } from "@mui/material";
import { BellIcon, MessageCircle } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useGetNotificationsGroupedCountQuery } from "web_myplann/Api/Notifications/useNotificationGroupedCountQuery";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { device, NavigationTypes } from "web_myplann/Utils/device";

type Props = {
	variant: "gradient" | "flat";
};

export const DashboardHeaderActions: FC<Props> = ({ variant }) => {
	const { palette } = useTheme();
	const navigate = useNavigate();
	const isDashboardV2 = useIsDashboardV2();
	const { data: notificationsGroupedCount } =
		useGetNotificationsGroupedCountQuery(true);

	const isGradient = variant === "gradient";

	const iconColor = isGradient
		? palette.darkmodeText.white
		: palette.deprecated.grey[700];

	const badgeSx = isGradient
		? {
				"& .MuiBadge-badge": {
					right: 5,
					top: 5,
					minWidth: 16,
					height: 16,
					fontSize: 8,
					fontWeight: 700,
					padding: "0 4px",
					color: palette.darkmodeText.white,
					border: `2px solid ${palette.darkmodeText.white}`,
				},
			}
		: {
				"& .MuiBadge-badge": {
					right: 5,
					top: 5,
					color: palette.getContrastText(palette.deprecated.error.main),
				},
			};

	const bellBadgeSx = isGradient
		? badgeSx
		: {
				"& .MuiBadge-badge": {
					right: 5,
					top: 5,
					color: palette.getContrastText(palette.deprecated.grey[700]),
				},
			};

	const bellColor = isGradient
		? palette.darkmodeText.white
		: palette.common.black;

	return (
		<>
			<IconButton
				sx={isGradient ? undefined : { padding: 0 }}
				onClick={() => {
					if (isDashboardV2) {
						navigate(Routing.Chat.List.path());
					} else {
						device.navigationRequest(NavigationTypes.ChatScreen);
					}
					if (isGradient) device.changeDashboardColor("");
				}}
			>
				<Badge
					badgeContent={notificationsGroupedCount?.chatCount}
					color="error"
					sx={badgeSx}
				>
					<MessageCircle color={iconColor} />
				</Badge>
			</IconButton>
			<IconButton
				sx={isGradient ? undefined : { padding: 0 }}
				onClick={() => {
					navigate(Routing.Notifications.path());
					if (isGradient) device.changeDashboardColor("");
				}}
			>
				<Badge
					badgeContent={notificationsGroupedCount?.count}
					color="error"
					sx={bellBadgeSx}
				>
					<BellIcon color={bellColor} />
				</Badge>
			</IconButton>
		</>
	);
};
